import { createApi, fetchBaseQuery, BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

// Custom base query that converts 404 "no records" into a successful empty response
const baseQueryWith404Handler: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const rawBaseQuery = fetchBaseQuery({
     baseUrl: process.env.REACT_APP_SERVER_ENDPOINT,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('authkey', '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3');
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  });

  const result = await rawBaseQuery(args, api, extraOptions);

  // If 404 and message says "No guest orders found" → treat as empty success
  if (result.error) {
    const status = result.error.status;
    const message = (result.error.data as any)?.message || '';
    if (status === 404 && message.toLowerCase().includes('no guest orders found')) {
      return { data: { orders: [] } };
    }
  }

  return result;
};

export const guestUserOrderApi = createApi({
  reducerPath: 'guestUserOrderApi',
  baseQuery: baseQueryWith404Handler,
  tagTypes: ['GuestOrder'],
  endpoints: (build) => ({
    listGuestOrders: build.query({
      query: () => ({
        url: 'user/adminGuestListOrders',
        method: 'POST',
        body: {},
      }),
      transformResponse: (response: any) => {
        if (!response) return { orders: [] };
        if (Array.isArray(response)) return { orders: response };
        if (Array.isArray(response.orders)) return response;
        if (Array.isArray(response.data)) return { orders: response.data };
        return { orders: [] };
      },
      providesTags: ['GuestOrder'],
    }),
  }),
});

export const {
  useListGuestOrdersQuery,
} = guestUserOrderApi;